<template>
  <div>
    <a
      class="variation-listing-filters-variation-entry-link"
      :href="`${builtQueryString}#list-page-start`"
      :title="entryDisplayValue(group, entry)"
      rel="nofollow"
      @click="isChecked = !isChecked"
    >
      <label
        v-if="group.variationDisplayType !== 'hex-color'"
        class="variation-listing-filters-variation-entry-name"
        :class="{
            'checked': isChecked || isFilterUsed(group, entry)
          }"
      >
        {{ entryDisplayValue(group, entry, { trim: true }) }}
      </label>
    </a>
  </div>
</template>

<script>

import VariationListingFiltersMixin from '../Mixins/VariationListingFiltersMixin'

export default {
  name: 'EntryFilter',
  mixins: [VariationListingFiltersMixin],
  props: {
    group: {
      variationDisplayType: '',
      variationGroupId: '',
      variationGroupName: null,
      variationGroupStep: 0,
      variationGroupDisplayPosition: 0,
      variations: []
    },
    entry: {
      variationActive: '',
      variationDisplayValue: '',
      variationId: '',
      variationName: '',
      variationOrder: ''
    }
  },
  data() {
    return {
      isChecked: false
    }
  },
  computed: {
    builtQueryString () {
      return this.filteringManage(this.group, this.entry)
    }
  },
  methods: {
    isHexGroup (displayType) {
      return displayType === 'hex-color'
    }
  }
}
</script>

<style lang="scss" scoped>
.variation-listing-filters-variation-entry-link {
  font-size: 14px;
}
.variation-listing-filters-variation-entry-name {
  color: #231F20;
  font-weight: 400;
  display: block;
  width: 100%;
  position: relative;
  margin: 0;
  line-height: 2;
  padding: 0 0 0 25px;
  font-size: 14px;
  cursor: pointer;
  &::before {
    content: "";
    position: absolute;
    top: 4px;
    background-color: #fff;
    z-index: 1;
    transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);
    transition-property: background-color, border-color;
    width: 20px;
    height: 20px;
    border: 1px solid #231F20;
    border-radius: unset;
    right: auto;
    left: 0;
  }
  &::after {
    content: "";
    position: absolute;
    height: 12px;
    border-bottom: 2px solid #fff;
    border-right: 2px solid #fff;
    transform: rotate(45deg);
    z-index: 2;
    transition: border-color 0.28s cubic-bezier(0.4, 0, 0.2, 1);
    width: 6px;
    top: 6px;
    right: unset;
    left: 8px;
  }
  &.checked {
    &::before {
      background-color: #231F20;
      border-color: #231F20;
    }
  }
}
</style>
